import { render } from "./TrabajoBaremo.vue?vue&type=template&id=30ef00b2&scoped=true"
import script from "./TrabajoBaremo.vue?vue&type=script&lang=js"
export * from "./TrabajoBaremo.vue?vue&type=script&lang=js"

import "./TrabajoBaremo.vue?vue&type=style&index=0&id=30ef00b2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ef00b2"]])

export default __exports__